import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {InputRow, PageHeader } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
        <PageHeader {...page}  subheading="This worksheet controls when and who receives receipts of your new Google Reviews.">Google Review Receipts</PageHeader>
        <InputRow {...page} keyName={LocationVarKey.GoogleReviewRatingTrigger} label="Rating Trigger (0-5)"/>
        <div className='cortexDescription'>Ratings less than or equal to this value will trigger a receipt to the comma-separated list of email addresses below.</div>
        <InputRow {...page} keyName={LocationVarKey.GoogleReviewEmailReceiptList} label="Email Receipt List"/>
    </>
}